import templateUrl from 'emun.customer/scan-badge/view-badge.htm'
import ViewBadgeController from 'emun.customer/scan-badge/view-badge.controller'
//import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'

const ViewBadge = {
	open(options) {
		return modals.open(angular.extend({
			size: 'lg',
			templateUrl,
			resolve: {
				options: () => options
			},
			bindToController: true,
			controller: ViewBadgeController,
			controllerAs: '$ctrl'
		}, (options || {}).modal)).result;
	}
};

export default ViewBadge;